<mat-card class="breadcrumb">
    <div class="row">
        <div class="col-md-7">
            <!--<a [routerLink]="['/dashboard']">Dashboard</a>-->
            <!--<mat-icon>arrow_forward_ios</mat-icon>-->
            <a [routerLink]="['/events']">Events</a>
        </div>
        <div class="col-md-5 text-right">
            <a mat-raised-button color="primary" (click)="create()">Create Event Tickets</a>

            <!-- <button *ngIf="(params$ | async).startDate || (params$ | async).endDate" type="button" class="btn btn-success" (click)="exportConfirm()" matTooltip="Export to CSV file">
               Export
            </button> -->

        </div>
    </div>
</mat-card>


<div class="mb-3 mt-3">


    <div class="mat-card mt-2 p-2">
        <div class="row">
            <div class="col-6">
                <mat-form-field appearance="outline" class="mb-0">
                    <mat-label>Event name</mat-label>
                    <input matInput type="text" autocomplete="off" name="searchText" [(ngModel)]="params.searchText" (keyup)="filterSearch()">
                </mat-form-field>
            </div>

            <div class="col-6 text-right">
                <mat-form-field appearance="outline" class="mb-0">
                    <mat-label> </mat-label>
                    <mat-select [(ngModel)]="params.limit" (ngModelChange)="filterSearch()">
                        <mat-option [value]="l" *ngFor="let l of params.limits">{{l}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>
    </div>


  </div>

  <div class="mat-card mt-2 p-2">
    <div class="card mb-3 no-records" *ngIf="!loading && !data.length">
        No results for the search criteria entered
    </div>
    <div class="card mb-3 no-records" *ngIf="loading">
        Loading data <i class="fa fa-spinner fa-spin"></i>
    </div>


    <div *ngIf="data.length">


        <table class="example-full-width data-listing">
            <thead>
            <tr>
                <th>
                    <a *ngIf="params.sort === 'event.name DESC'" (click)="setSort('event.name')">Name <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.name DESC'" (click)="setSort('event.name DESC')">Name <i class="fa fa-angle-down"></i></a>
                </th>
                <th>
                    <a *ngIf="params.sort === 'event.location DESC'" (click)="setSort('event.location')">Location <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.location DESC'" (click)="setSort('event.location DESC')">Location <i class="fa fa-angle-down"></i></a>
                </th>
                <th>
                    <a *ngIf="params.sort === 'event.stDate DESC'" (click)="setSort('event.stDate')">Dates <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.stDate DESC'" (click)="setSort('event.stDate DESC')">Dates <i class="fa fa-angle-down"></i></a>
                </th>
                <th>
                    <a *ngIf="params.sort === 'event.stTime DESC'" (click)="setSort('event.stTime')">Times <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.stTime DESC'" (click)="setSort('event.stTime DESC')">Times <i class="fa fa-angle-down"></i></a>
                </th>
                <th class="d-none d-lg-table-cell">
                    <a *ngIf="params.sort === 'event.active DESC'" (click)="setSort('event.active')">Active <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.active DESC'" (click)="setSort('event.active DESC')">Active <i class="fa fa-angle-down"></i></a>
                </th>
                <th>
                    <a *ngIf="params.sort === 'event.type DESC'" (click)="setSort('event.type')">Variants <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.type DESC'" (click)="setSort('event.type DESC')">Variants <i class="fa fa-angle-down"></i></a>
                </th>
                <th>
                    <a *ngIf="params.sort === 'event.type DESC'" (click)="setSort('event.type')">Attendees <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.type DESC'" (click)="setSort('event.type DESC')">Attendees <i class="fa fa-angle-down"></i></a>
                </th>

                <!-- <th style="min-width: 90px" class="d-none d-xl-table-cell">
                    <a *ngIf="params.sort === 'event.createdAt DESC'" (click)="setSort('event.createdAt')">Created <i class="fa fa-angle-up"></i></a>
                    <a *ngIf="params.sort !== 'event.createdAt DESC'" (click)="setSort('event.createdAt DESC')">Created <i class="fa fa-angle-down"></i></a>
                </th> -->
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of data; let i = index" [ngClass]="{'tr-odd': isOdd(i)}">
                <td class="hover" (click)="update(data)">
                    {{data.name}}
                </td>
                <td class="hover" (click)="update(data)">{{data.location}}</td>
                <td class="hover" (click)="update(data)">{{data.stDate | date: 'dd/MM/yyyy'}}<span *ngIf="data.stDate !== data.endDate"> - {{data.endDate | date: 'dd/MM/yyyy'}}</span></td>
                <td class="hover" (click)="update(data)">{{data.stTime}} - {{data.endTime}}</td>
                <td style="width: 175px">
                    <mat-icon *ngIf="data.active">check</mat-icon>
                    <mat-icon *ngIf="!data.active">remove</mat-icon>
                </td>

                <td class="hover" (click)="update(data)">{{data.skus.length}}</td>
                <td *ngIf="data.attendees > 0">
                    <a class="hover" [routerLink]="['/events', 'attendees', data.id]">{{data.attendees}} of {{data.capacity}}</a>
                </td>
                <td *ngIf="data.attendees <= 0">-</td>

                <!-- <td class="d-none d-xl-table-cell">{{data.createdAt | date:'dd MMM yyyy'}}</td> -->
                  <td class="text-right">
                      <button mat-icon-button [matMenuTriggerFor]="menu">
                          <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="update(data)">
                              <mat-icon>edit</mat-icon>
                              <span>Edit</span>
                          </button>
                          <button mat-menu-item (click)="visitEvent(data)">
                                <mat-icon>link</mat-icon>
                                <span>View on site</span>
                            </button>
                        <button mat-menu-item (click)="delete(data)">
                              <mat-icon>delete</mat-icon>
                              <span>Delete</span>
                          </button>
                      </mat-menu>

                      <!-- <a [href]="'https://rooms.norfolkpassport.com/events/' + data.eventType.slug + '/' + data.slug" target="_blank" class="hover ml-3">
                        <i class="fa fa-link"></i>
                    </a> -->

                    </td>
            </tr>
            </tbody>
        </table>

        <app-pagination [params]="params" (update)="search()"></app-pagination>

    </div>

  </div>

  <app-confirmation *ngIf="dataToDelete" [data]="deleteConfirmation" (complete)="deleteAction($event)"></app-confirmation>
